
import React, { Component } from 'react';
import { css, StyleSheet } from 'aphrodite';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';


function LeftArrow(props) {
  const { onClick } = props;
  return (
    <div className={css(Styles.iconContainer)}>
      <div
        className={props.currentSlide === 0
          ?
          css(Styles.arrowIconsDisabled)
          :
          css([Styles.relatedImageSelectionContent, Styles.relatedImageSelectionContentTop])}
        onClick={onClick} >
        <ExpandLessIcon
          className={css(Styles.arrowIcons)} />
      </div>
    </div>
  );
}

function RightArrow(props) {
  const { onClick } = props;
  return (
    <div className={css(Styles.iconContainer)}>
      <div
        className={props.currentSlide === props.slideCount - slidesToScroll
          ?
          css(Styles.arrowIconsDisabled)
          :
          css([Styles.relatedImageSelectionContent, Styles.relatedImageSelectionContentBottom])}
        onClick={onClick} >
        <ExpandMoreIcon
          className={css(Styles.arrowIcons)} />
      </div>
    </div>
  );
}

const slidesToScroll = 2
export const productImageSliderSettings = {
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: slidesToScroll,
  lazyLoad: 'ondemand',
  vertical: true,
  nextArrow: <RightArrow />,
  prevArrow: <LeftArrow />,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

const Styles = StyleSheet.create({
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent'
  },
  relatedImageSelectionContent: {
    width: '100%',
    height: 25,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'white',
    marginLeft: '6px',
    marginTop: '3px',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: 'lightgrey'
    }
  },
  relatedImageSelectionContentTop: {
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    boxShadow: '0 2px 20px 0 rgba(0, 0, 30, 0.1), inset 0 -1px 1px 0 rgba(149, 149, 149, 0.5);'
  },
  relatedImageSelectionContentBottom: {
    borderBottomLeftRadius: 15,
    borderBottomRightRadius: 15,
    boxShadow: '0 2px 20px 0 rgba(0, 0, 30, 0.1), inset 0 -1px 1px 0 rgba(149, 149, 149, 0.5);'
  },
  arrowIcons: {
    fontSize: 30
  },
  arrowIconsDisabled: {
    display: 'none',
  },
})


// WEBPACK FOOTER //
// ./src/components/ProductSliderSettings.js